import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';

import Form from './Form';
import Styled from './style';
// import Radio from 'globalcomponents/UI/Radio';
// import Payment from 'globalcomponents/Payment';
import { hasValue } from 'globalutils/fmUtils';

import CircularProgress from '@material-ui/core/CircularProgress';
// import {FormStyle}  from 'globalcomponents/UI/Form/Clutch/serverStyle';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() =>
  import(`globalcomponents/UI/Button/${layout}`)
);
const Checkbox = lazy(() =>
  import(`globalcomponents/UI/Checkbox/${layout}`)
);

const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);

const Component = ({
  apiStatus,
  requestForgotPassword,
  history,
  clearApiStatus,
  states,
  addCompanyInfo,
  getCompanyInfoApi,
  getCompanyInfo,
  checkoutDetails,
  getFleetManagerInfo,
  addCheckout,
  callback,
  companyInfo,
  addMoreTrucks,
  clearCompanyInfoValues,
  clearFleetInfoValues,
  clearTruckInfoValues
}) => {
  const apiId = 'addCompany';
  const hasApiStatus = hasValue(apiStatus.status, 'api', apiId);
  const [differentAddress, setdifferentAddress] = useState(false);
  const [subPerCost, setSubPerCost] = useState(null);
  const [subFilterOption, setSubFilterOption] = useState('Yearly');
  const [selectedPlanIndex, setSelectedPlanIndex] = useState(0);
  // const [totalCost, setTotalCost] = useState(null);
  const [totalBill, setTotalBill] = useState(null);
  const [strikeOut, setStrikeOut] = useState(null);
  const plans = checkoutDetails?.plans ?? [];
  const selectedPlan = plans[selectedPlanIndex] ?? null;

  useEffect(() => {
    if (plans.length > 0 && selectedPlanIndex >= plans.length) {
      setSelectedPlanIndex(0);
    }
  }, [plans.length, selectedPlanIndex]);

  const differentAddressFn = (event) => {
    setdifferentAddress(event);
  };
  useEffect(() => {
    !differentAddress
      ? (document.getElementById('shipppingAddress').style.display = 'none')
      : (document.getElementById('shipppingAddress').style.display = 'flex');
  }, [differentAddress]);

  useEffect(() => {
    if (selectedPlan) {
      if (subFilterOption === 'Yearly') {
        setSubPerCost(selectedPlan.subscriptionFeePerYear);
        setTotalBill(selectedPlan.totalBillYearly);
        setStrikeOut(selectedPlan.totalBillYearlyBasedOnMonthlySubscriptionFee);
      } else {
        setSubPerCost(selectedPlan.subscriptionFeePerMonth);
        setTotalBill(selectedPlan.totalBillMonthly);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subFilterOption, selectedPlanIndex, checkoutDetails]);
  const subFilter = (planIndex) => {
    setSelectedPlanIndex(planIndex);
    setSubFilterOption('Yearly');
  };
  const yearlySubscriptionFeeAllTrucks =
    selectedPlan?.yearlySubscriptionFeeAllTrucks ?? 0;
  const monthlySubscriptionFeeAllTrucks =
    selectedPlan?.monthlySubscriptionFeeAllTrucks ?? 0;

  const addMoreFromCheckout = () => {
    addMoreTrucks();
    clearCompanyInfoValues({
      id: 'clearCompanyInfoValues'
    });
    clearFleetInfoValues({
      id: 'clearFleetInfoValues'
    });
    clearTruckInfoValues({
      id: ' clearTruckInfoValues'
    });
  };

  return (
    <Styled.Wrapper>
      <h1 className="stepTitle">Checkout</h1>
      <div className="mainWrapper">
        <div className="leftWrapper">
          <Styled.SubWrapper>
            <div className="selectSub">
              <div className="selectSubscription">Subscription Plans</div>
              <div className="subBtnWrapper" id={'subBtnWrapper'}>
                {plans.map((plan, index) => (
                  <div key={plan.planName} className="buttonToggle">
                    <Button
                      label={plan.planName}
                      className={`subFilterButton ${selectedPlanIndex === index ? 'active' : ''}`}
                      onClick={() => subFilter(index)}
                    />
                  </div>
                ))}
              </div>
              <div className="vehicleCount">
                <span className="countList">
                  Current Vehicle Count :{' '}
                  <span className="count">
                    {checkoutDetails?.currentVehicleCount ?? 0}
                  </span>
                </span>
                <Button
                  className="addMore"
                  label={'Add more'}
                  onClick={() => addMoreFromCheckout()}
                ></Button>
              </div>
              <Styled.FeeWrapper>
                <div className="perYearWrapper">
                  {' '}
                  <div>
                    {subFilterOption === 'Yearly'
                      ? 'Subscription Fee (per two year) '
                      : 'Subscription Fee (per month) '}
                  </div>
                  <div className="yearSub">${(subPerCost ?? 0).toFixed(2)}</div>
                </div>
                {subFilterOption === 'Yearly' ? (
                  <div className="setupWrapper">
                    <span className="settepText">Setup Fee</span>
                    <span className="setupFee yearly">
                      ${selectedPlan?.setupFee?.toFixed(2)}
                    </span>
                  </div>
                ) : (
                  <div className="setupWrapper monthlyFee">
                    Setup Fee
                    <span className="setupFee">
                      ${selectedPlan?.setupFee?.toFixed(2)}
                    </span>
                  </div>
                )}
              </Styled.FeeWrapper>
            </div>
          </Styled.SubWrapper>

          <Styled.ShippingWrapper>
            <div className="subHeading">Shipping Options</div>
            <div className="radioButtons">
              <Checkbox checked={true} onClick={() => { }} />
              <span className="checkbox-label">
                Standard shipping & Handling -{' '}
                <span>${(selectedPlan?.shippingFee ?? 0).toFixed(2)}</span> (3-5
                Business Days)
              </span>
            </div>
            <Checkbox
              type="NormalWhite"
              label={
                'Check here if shipping address is different than billing address'
              }
              checked={differentAddress}
              onClick={(event) => {
                differentAddressFn(event);
              }}
              id="selectedAddress"
            />
          </Styled.ShippingWrapper>
          <div id="shippingAddress">
            <Form
              apiStatus={apiStatus}
              requestForgotPassword={requestForgotPassword}
              history={history}
              clearApiStatus={clearApiStatus}
              states={states}
              addCompanyInfo={addCompanyInfo}
              getCompanyInfoApi={getCompanyInfoApi}
              getCompanyInfo={getCompanyInfo}
              getFleetManagerInfo={getFleetManagerInfo}
              addCheckout={addCheckout}
              differentAddress={differentAddress}
              totalBill={totalBill}
              subFilterOption={subFilterOption}
              checkoutDetails={checkoutDetails}
              selectedPlan={selectedPlan}
              yearlySubscriptionFeeAllTrucks={yearlySubscriptionFeeAllTrucks}
              callback={callback}
              companyInfo={companyInfo}
            />
          </div>
        </div>
        <div className="rightWrapper">
          <div className="paymentWrapper">
            <ul className="calculator">
              <li className="subscription">
                {' '}
                <div>
                  <span>
                    {subFilterOption === 'Yearly'
                      ? `${selectedPlan?.planName ?? ''} Subscription `
                      : 'Monthly Subscription '}
                  </span>
                  <span className="year">
                    <span>x</span>
                    {checkoutDetails?.currentVehicleCount ?? 0}
                  </span>
                </div>{' '}
                <span className="count">
                  $
                  {(subFilterOption === 'Yearly'
                    ? yearlySubscriptionFeeAllTrucks
                    : monthlySubscriptionFeeAllTrucks
                  ).toFixed(2)}
                </span>
              </li>
              {subFilterOption === 'Monthly' && (selectedPlan?.taxesMonthly ?? 0) > 0 ? (
                <li>
                  Taxes{' '}
                  <span className="count">
                    $ {(selectedPlan?.taxesMonthly ?? 0).toFixed(2)}
                  </span>
                </li>
              ) : subFilterOption === 'Yearly' && (selectedPlan?.taxesYearly ?? 0) > 0 ? (
                <li>
                  Taxes{' '}
                  <span className="count">
                    $ {(selectedPlan?.taxesYearly ?? 0).toFixed(2)}
                  </span>
                </li>
              ) : (
                ''
              )}
              <li>
                Shipping{' '}
                <span className="count">
                  ${(selectedPlan?.shippingFee ?? 0).toFixed(2)}
                </span>
              </li>
              <li className="setWrapper">
                {' '}
                <span
                  className={subFilterOption === 'Monthly' ? '.nodim' : 'dim'}
                >
                  Setup Fee
                </span>
                {subFilterOption === 'Monthly' ? (
                  <span className="setupFee">
                    {' '}
                    ${(selectedPlan?.setupFee ?? 0).toFixed(2)}
                  </span>
                ) : (
                  <span className="setupFee yearly">
                    ${(selectedPlan?.setupFee ?? 0).toFixed(2)}
                  </span>
                )}
              </li>
            </ul>
            {subFilterOption === 'Yearly' ? (
              <ul className="strikeOut">
                {' '}
                <span className="count">${(strikeOut ?? 0).toFixed(2)}</span>
              </ul>
            ) : (
              ''
            )}
            <ul className="totalCalculator">
              <span>Total due today</span>{' '}
              <span className="amountTotal">$ {(totalBill ?? 0).toFixed(2)}</span>
            </ul>
            {/* <Payment buttonLabel= {'Pay Now'} updateCard= {(data) => cardDetails(data)}/> */}
            <FormStyle.default.ButtonsWrapper className="registerButton">
              <Button
                type="submit"
                label={
                  hasApiStatus?.isLoading ? (
                    <CircularProgress color="inherit" />
                  ) : (
                    'Register'
                  )
                }
                onClick={() => {
                  document.getElementById('checkOutSubmit').click();
                }}
              />
            </FormStyle.default.ButtonsWrapper>
          </div>
        </div>
      </div>
    </Styled.Wrapper>
  );
};

export default Component;

Component.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  requestForgotPassword: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  clearApiStatus: PropTypes.func.isRequired
};
